import { render } from "./GlobalTotalCumule.vue?vue&type=template&id=26ff4b7e"
import script from "./GlobalTotalCumule.vue?vue&type=script&lang=js"
export * from "./GlobalTotalCumule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__